var map = {
	"./beatles.jpg": "d786",
	"./cdplayer.png": "ebd7",
	"./logo.png": "cf05",
	"./patterns/bait-and-switch.jpg": "f751",
	"./patterns/confirmshaming.png": "92ad",
	"./patterns/disguised-ads.jpg": "315d",
	"./patterns/friend-spam.png": "9219",
	"./patterns/hidden-costs.png": "c9ea",
	"./patterns/price-comparison-prevention.png": "5987",
	"./patterns/price-zuckering.png": "3a69",
	"./patterns/roach-motel.png": "386d",
	"./patterns/sneak-into-basket.png": "3814",
	"./patterns/trick-question.jpg": "427e",
	"./radiohead.jpg": "8332",
	"./rhcp.jpg": "edbc",
	"./tose.jpg": "94a0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";